<template>
  <DatePicker
    v-model="date"
    :mode="isDateTime ? 'dateTime' : 'date'"
    :is24hr="is24hr"
    :valid-hours="validHours"
    :minute-increment="minuteIncrement"
    :min-date="minDate"
    @input="onChange"
  >
    <template #default="{ inputValue, inputEvents }">
      <input
        :id="inputId"
        :class="inputClass"
        :value="inputValue"
        :placeholder="placeholder"
        :name="name"
        :disabled="!editing"
        @click="inputEvents.focusin"
        @blur="inputOnBlur"
      />
    </template>
  </DatePicker>
</template>

<script lang="ts">
import { DatePicker } from 'v-calendar'
import { Vue } from 'vue-property-decorator'

export default Vue.extend({
  name: 'DateTimePicker',
  components: {
    DatePicker
  },
  props: {
    isDateTime: {
      type: Boolean,
      default: true
    },
    is24hr: {
      type: Boolean,
      default: false
    },
    onChange: {
      type: Function,
      required: false,
      default: (date: { start: string; end: string }) => String // eslint-disable-line
    },
    name: {
      type: String,
      default: null
    },
    inputId: {
      type: String,
      default: null
    },
    placeholder: {
      type: String,
      default: ''
    },
    value: {
      type: String,
      default: '',
      required: false
    },
    editing: {
      type: Boolean,
      default: false
    },
    inputClass: {
      type: String,
      default: ''
    },
    validHours: {
      type: [Object, Array],
      default: () => ({ min: 0, max: 23 })
    },
    minuteIncrement: {
      type: Number,
      default: 1
    },
    minDate: {
      type: Date,
      default: null
    }
  },
  data() {
    return {
      date: ''
    }
  },
  watch: {
    value(value: string) {
      if (value && value != '' && value != null) {
        this.date = new Date(value).toString()
      } else {
        this.date = ''
      }
    }
  },
  methods: {
    inputOnBlur(event) {
      const value = event?.srcElement.value || null
      if (value && value != '' && value != null) {
        this.date = new Date(value).toString()
      } else {
        this.date = ''
      }
    }
  }
})
</script>
